export const availableRoutes = {
  HOME: '/',
  TERMS_AND_CONDITIONS: '/algemene-voorwaarden',
}
